import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix USD icon. Exported from Figma (Bombiix 2026). */
const USDIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M6.66602 12.6667C7.33268 13.3333 8.66602 14 9.99935 14M9.99935 14C11.666 14 13.3327 13.6667 13.3327 12C13.3327 10.3333 11.699 10 9.99935 10M9.99935 14V10M9.99935 14V16M9.99935 10C8.33268 10 6.66602 9.66667 6.66602 8C6.66602 6.33333 8.33268 6 9.99935 6M9.99935 10V6M9.99935 6C11.3327 6 12.666 6.66667 13.3327 7.33333M9.99935 6V4"
      stroke="currentColor"
    />
  </svg>
);

export default USDIcon;
